import { ICON_MAPPING } from './icons'
import * as battery0 from '@/../images/icons/theben/battery0.svg'
import * as battery20 from '@/../images/icons/theben/battery20.svg'
import * as battery40 from '@/../images/icons/theben/battery40.svg'
import * as battery60 from '@/../images/icons/theben/battery60.svg'
import * as battery80 from '@/../images/icons/theben/battery80.svg'
import * as battery100 from '@/../images/icons/theben/battery100.svg'
import * as chp from '@/../images/icons/theben/chp.svg'
import * as container from '@/../images/icons/theben/container.svg'
import * as containerAlarm from '@/../images/icons/theben/container_alarm.svg'
import * as containerOk from '@/../images/icons/theben/container_ok.svg'
import * as containerWarning from '@/../images/icons/theben/container_warning.svg'
import * as wallbox from '@/../images/icons/theben/wallbox.svg'
import * as wallboxPlugged from '@/../images/icons/theben/wallbox_plugged.svg'
import * as wallboxUnplugged from '@/../images/icons/theben/wallbox_unplugged.svg'
import * as wallboxWarning from '@/../images/icons/theben/wallbox_warning.svg'
import * as fuelcell from '@/../images/icons/theben/fuelcell.svg'
import * as generic from '@/../images/icons/theben/generic.svg'
import * as grid from '@/../images/icons/theben/grid.svg'
import * as heatingelement from '@/../images/icons/theben/heatingelement.svg'
import * as heatpump from '@/../images/icons/theben/heatpump.svg'
import * as pv from '@/../images/icons/theben/pv.svg'
import * as rest from '@/../images/icons/theben/rest.svg'
import * as trafo from '@/../images/icons/theben/trafo.svg'
import * as user from '@/../images/icons/theben/user.svg'

const map = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  container,
  containerAlarm,
  containerOk,
  containerWarning,
  fuelcell,
  generic,
  grid,
  heatingelement,
  heatpump,
  pv,
  rest,
  trafo,
  user,
  wallbox,
  wallboxPlugged,
  wallboxUnplugged,
  wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}
